import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectFlatsSearch } from '../../../../../../../lib/storeSelectors';

export const useSearch = () => {
  const search = useSelector(selectFlatsSearch);

  const [debouncedSearch, setDebouncedSearch] = useState(search);

  useEffect(() => {
    let timeout;

    timeout = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);

  return debouncedSearch;
};
